import React from "react";

type FeatureProps = {
  title: string;
};

const Feature: React.FC<FeatureProps> = ({ title }) => {
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary-50/30 text-primary-900">
        ✓
      </div>
      <span>{title}</span>
    </div>
  );
};

export default Feature;
